import { useEffect, useState } from "react";
import { Activity as ActivityIcon, Calendar, ListChecks, CheckCircle2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import TopNav from "@/components/TopNav";

export default function Activity() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/me/activity").then((r) => setRows(r.data)).catch((e) => { toast.error(apiErr(e)); setRows([]); }); }, []);

  return (
    <div className="min-h-screen">
      <TopNav />
      <main className="max-w-5xl mx-auto px-4 sm:px-8 pt-10 pb-24">
        <span className="pill text-[11px] tracking-[0.2em] px-4 py-1.5 glass text-teal-accent inline-block">MY ACTIVITY</span>
        <h1 className="serif text-4xl sm:text-5xl font-extrabold mt-5">Activity</h1>
        <p className="text-muted-foreground mt-3 max-w-xl">Your enrolled courses and progress at a glance.</p>

        {rows === null ? (
          <p className="text-teal-accent mt-10">Loading…</p>
        ) : rows.length === 0 ? (
          <div className="glass-strong rounded-3xl p-10 mt-10 text-center">
            <ActivityIcon size={30} className="text-teal-accent mx-auto mb-3" />
            <p className="text-muted-foreground">You haven't enrolled in any course yet.</p>
          </div>
        ) : (
          <div className="space-y-4 mt-8">
            {rows.map((r, i) => (
              <div key={i} data-testid={`activity-row-${i}`} className="glass-strong rounded-2xl p-6">
                <h3 className="serif text-xl font-bold mb-4">{r.course_name}</h3>
                <div className="grid sm:grid-cols-3 gap-4">
                  <Field icon={Calendar} label="Course Started" value={r.started || "-"} />
                  <Field icon={ListChecks} label="Task Details" value={r.task_details} accent />
                  <Field icon={CheckCircle2} label="Completed" value={r.completed} accent={r.completed !== "-"} />
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

function Field({ icon: Icon, label, value, accent }) {
  return (
    <div className="glass rounded-xl px-4 py-3">
      <div className="text-[11px] uppercase tracking-widest text-muted-foreground flex items-center gap-1.5 mb-1"><Icon size={13} className="text-teal-accent" /> {label}</div>
      <div className={`text-sm font-medium ${accent ? "text-teal-accent" : ""}`}>{value}</div>
    </div>
  );
}
